/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ReferencedEntityNullableLongDto } from './ReferencedEntityNullableLongDto';
import {
    instanceOfReferencedEntityNullableLongDto,
    ReferencedEntityNullableLongDtoFromJSON,
    ReferencedEntityNullableLongDtoFromJSONTyped,
    ReferencedEntityNullableLongDtoToJSON,
} from './ReferencedEntityNullableLongDto';

/**
 * @type CreateEnumerationValueDtoValue
 * 
 * @export
 */
export type CreateEnumerationValueDtoValue = ReferencedEntityNullableLongDto;


export function CreateEnumerationValueDtoValueFromJSON(json: any): CreateEnumerationValueDtoValue {
    return CreateEnumerationValueDtoValueFromJSONTyped(json, false);
}

export function CreateEnumerationValueDtoValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEnumerationValueDtoValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...ReferencedEntityNullableLongDtoFromJSONTyped(json, true) };
    return  ReferencedEntityNullableLongDtoFromJSONTyped(json, true);
}

export function CreateEnumerationValueDtoValueToJSON(value?: CreateEnumerationValueDtoValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfReferencedEntityNullableLongDto(value)) {
        return ReferencedEntityNullableLongDtoToJSON(value as ReferencedEntityNullableLongDto);
    }

    return {};
}

/**
 * Check if a given object implements the CreateEnumerationValueDtoValue interface.
 */
export function instanceOfCreateEnumerationValueDtoValue(value: any): value is CreateEnumerationValueDtoValue {
    if (instanceOfReferencedEntityNullableLongDto(value)) return true;
    return false;
}

